<div class="content">
  <app-order-set-form #orderSetForm [orderSet]="orderSet"></app-order-set-form>
</div>

<div class="footer">
  <button pButton pRipple type="button" (click)="closeDialog()">Cancel</button>
  <button pButton pRipple type="button" (click)="onSubmit()" [disabled]="!isFormValid">
    {{ btnLabel }} Order Set
  </button>
</div>